import React from 'react';
import Icon from '../../../components/AppIcon';

const HISTORICAL = [
  { period: 'January 2025', emirate: 'All Emirates', date: '2025-01-31', highlights: 'Dubai led with 8.2% YoY growth; Abu Dhabi off-plan surged 22%' },
  { period: 'December 2024', emirate: 'All Emirates', date: '2024-12-31', highlights: 'Record Q4 transactions; Sharjah affordable segment up 11%' },
  { period: 'November 2024', emirate: 'All Emirates', date: '2024-11-30', highlights: 'RAK tourism-linked properties gained 15%; new RERA escrow rules' },
  { period: 'October 2024', emirate: 'All Emirates', date: '2024-10-31', highlights: 'Expat buying hit 5-year high; AED 2M visa threshold driving demand' },
  { period: 'September 2024', emirate: 'All Emirates', date: '2024-09-30', highlights: 'Off-plan launches exceeded 12,000 units; DLD fee waiver extended' },
];

const HistoricalReports = ({ onLoadReport }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Archive" size={16} className="text-gray-600" />
        <h3 className="font-semibold text-gray-900 text-sm">Historical Reports Archive</h3>
      </div>
      <div className="space-y-2">
        {HISTORICAL?.map((r, i) => (
          <div key={i} className="flex items-center gap-3 p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors">
            <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name="FileText" size={14} className="text-gray-500" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-gray-800">{r?.period}</span>
                <span className="text-xs text-gray-400">·</span>
                <span className="text-xs text-gray-500">{r?.emirate}</span>
              </div>
              <p className="text-xs text-gray-500 truncate mt-0.5">{r?.highlights}</p>
            </div>
            <button
              onClick={() => onLoadReport?.(r)}
              className="text-blue-600 hover:text-blue-800 text-xs font-medium flex items-center gap-1 flex-shrink-0"
            >
              <Icon name="Eye" size={12} />
              View
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HistoricalReports;
